import { GET } from './api'

export const Read = async () => {
    return await GET(`/indicators`, true);
}
